import { RpcService } from '../RpcService';
import { AbstractInputService } from './AbstractInputService';
import { IInputService } from './inputServiceTypes';

export class InputService
	extends AbstractInputService
	implements IInputService
{
	private buttonEnabled = true;

	constructor(private readonly rpc: RpcService) {
		rpc.register('input:copyToClipboard', (payload: any) => {
			this.copyToClipboard(payload.text);
		});

		super();
	}

	public async setEscButtonEnabled(isEnabled: boolean): Promise<void> {
		if (this.buttonEnabled === isEnabled) {
			return;
		}
		this.buttonEnabled = isEnabled;

		await this.rpc.invokeClient('input:setEscButtonEnabled', { isEnabled });
	}

	public async setAnyInputFocused(isFocused: boolean): Promise<void> {
		this.setIsAnyInputFocusedLocal(isFocused);

		return this.rpc.invokeClient('input:setAnyInputFocused', { isFocused });
	}
}
